
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cases/quick",
      function () {
        return require("private-next-pages/cases/quick/index.tsx");
      }
    ]);
  